/* ============================================================
   faünt — Combined JavaScript
   Extracted from v14-warm1.html, product.html, shop.html
   ============================================================ */

// ── MOBILE NAV ─────────────────────────────────────────────────
(function initMobileNav() {
  const btn = document.getElementById('navHamburger');
  const overlay = document.getElementById('navMobileOverlay');
  if (!btn || !overlay) return;
  btn.addEventListener('click', () => {
    const isOpen = overlay.classList.toggle('open');
    btn.classList.toggle('open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });
  overlay.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      overlay.classList.remove('open');
      btn.classList.remove('open');
      document.body.style.overflow = '';
    });
  });
})();

// ── SCROLL REVEAL ──────────────────────────────────────────────
(function initReveal() {
  const revealEls = document.querySelectorAll('.reveal');
  if (!revealEls.length) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  revealEls.forEach(el => observer.observe(el));
})();

// ── UGC DRAG SCROLL (homepage) ─────────────────────────────────
(function initUgcDragScroll() {
  const dragScroll = document.querySelector('.ugc-scroll-wrap');
  if (!dragScroll) return;
  let isDown = false, startX, scrollLeft;
  dragScroll.addEventListener('mousedown', e => {
    isDown = true;
    startX = e.pageX - dragScroll.offsetLeft;
    scrollLeft = dragScroll.scrollLeft;
  });
  dragScroll.addEventListener('mouseleave', () => isDown = false);
  dragScroll.addEventListener('mouseup', () => isDown = false);
  dragScroll.addEventListener('mousemove', e => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - dragScroll.offsetLeft;
    dragScroll.scrollLeft = scrollLeft - (x - startX) * 1.5;
  });
})();

// ── PDP — SHARED PRICE STATE ──────────────────────────────────
// Used by scent switcher, qty selector, and purchase tabs
let _pdpUnitCents = 0;
let _pdpQty = 1;
let _pdpIsSub = false;

function _parseCents(str) {
  return Math.round(parseFloat((str || '0').replace(/[^0-9.]/g, '')) * 100);
}
function _fmtCents(cents) {
  return '$' + (cents / 100).toFixed(2);
}
function _pdpRefresh() {
  if (!_pdpUnitCents) return;
  const unitDisplay = _pdpIsSub ? Math.round(_pdpUnitCents * 0.85) : _pdpUnitCents;
  const total = unitDisplay * _pdpQty;
  const priceEl = document.querySelector('.pdp-price');
  if (priceEl) priceEl.textContent = _fmtCents(total);
}

// ── PDP — SCENT SWITCHER ───────────────────────────────────────
(function initScentSwitcher() {
  const mainImg = document.getElementById('mainImage');
  const breadcrumb = document.getElementById('breadcrumb-text');
  if (!mainImg) return;

  function updateYmal(scent) {
    document.querySelectorAll('.ymal-card[data-ymal-scent]').forEach(card => {
      card.style.display = card.dataset.ymalScent === scent ? 'none' : '';
    });
  }

  document.querySelectorAll('.scent-swatch').forEach(btn => {
    btn.addEventListener('click', () => {
      const scent = btn.dataset.scent;
      const img = btn.dataset.image;
      const price = btn.dataset.price;
      const vid = btn.dataset.variantId;
      const isAvailable = btn.dataset.available === 'true';
      document.querySelectorAll('.scent-swatch').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const atcBtn = document.getElementById('atcBtn');
      if (atcBtn) {
        atcBtn.disabled = !isAvailable;
        atcBtn.textContent = isAvailable ? (atcBtn.dataset.availableText || 'Add to Cart') : 'Sold Out';
      }

      mainImg.classList.add('fade');
      setTimeout(() => {
        if (img) mainImg.src = img;
        if (vid) { const vi = document.getElementById('variant-id'); if (vi) vi.value = vid; }
        if (price) {
          const op = document.getElementById('onetime-price');
          if (op) op.textContent = price;
          const subSub = document.querySelector('#tab-subscribe .purchase-tab-sub');
          if (subSub) subSub.textContent = _fmtCents(Math.round(_parseCents(price) * 0.85)) + ' · Save 15%';
          _pdpUnitCents = _parseCents(price);
          _pdpRefresh();
        }
        if (breadcrumb) breadcrumb.textContent = 'Shop / Whole Body Deodorant / ' + btn.textContent.trim();
        mainImg.classList.remove('fade');
      }, 280);
      updateYmal(scent);
    });
  });

  // Init price state from active swatch
  const activeScent = document.querySelector('.scent-swatch.active');
  if (activeScent) {
    updateYmal(activeScent.dataset.scent);
    if (activeScent.dataset.price) _pdpUnitCents = _parseCents(activeScent.dataset.price);
  }
  // Fallback: read from rendered pdp-price
  if (!_pdpUnitCents) {
    const priceEl = document.querySelector('.pdp-price');
    if (priceEl) _pdpUnitCents = _parseCents(priceEl.textContent);
  }
})();

// ── PDP — THUMBNAIL GALLERY ────────────────────────────────────
(function initThumbGallery() {
  const mainImg = document.getElementById('mainImage');
  if (!mainImg) return;
  document.querySelectorAll('.pdp-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.pdp-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      mainImg.classList.add('fade');
      setTimeout(() => {
        mainImg.src = thumb.dataset.src;
        mainImg.classList.remove('fade');
      }, 280);
    });
  });
})();

// ── PDP — VIDEO GALLERY MODAL (prev/next + swipe navigation) ───
(function initVideoGalleryModals() {
  document.querySelectorAll('[data-video-modal]').forEach(function (modal) {
    const gallery = modal.closest('.video-gallery');
    if (!gallery) return;
    const openBtns = Array.from(gallery.querySelectorAll('[data-video-open]'));
    const slides = Array.from(modal.querySelectorAll('[data-video-slide]'));
    const closeBtns = modal.querySelectorAll('[data-video-modal-close]');
    const prevBtn = modal.querySelector('[data-video-prev]');
    const nextBtn = modal.querySelector('[data-video-next]');
    if (!openBtns.length || !slides.length) return;

    let currentIndex = 0;

    function pauseAll() {
      slides.forEach(function (slide) {
        slide.hidden = true;
        const video = slide.querySelector('video');
        if (video) video.pause();
      });
    }

    function showIndex(index) {
      const clamped = ((index % slides.length) + slides.length) % slides.length;
      pauseAll();
      currentIndex = clamped;
      const slide = slides[clamped];
      if (!slide) return;
      slide.hidden = false;
      const video = slide.querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.play().catch(function () {});
      }
    }

    function setCardPreviewsPlaying(playing) {
      openBtns.forEach(function (btn) {
        const preview = btn.querySelector('video');
        if (!preview) return;
        if (playing) preview.play().catch(function () {});
        else preview.pause();
      });
    }

    function open(index) {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      setCardPreviewsPlaying(false);
      showIndex(index);
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      setCardPreviewsPlaying(true);
      pauseAll();
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(parseInt(btn.dataset.videoIndex, 10) || 0);
      });
    });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    if (prevBtn) prevBtn.addEventListener('click', function () { showIndex(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showIndex(currentIndex + 1); });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') showIndex(currentIndex - 1);
      if (e.key === 'ArrowRight') showIndex(currentIndex + 1);
    });

    // Swipe navigation (mobile) — a horizontal drag on the stage steps
    // to the previous/next video instead of requiring the arrow buttons.
    let touchStartX = null;
    const stage = modal.querySelector('.video-gallery-modal-stage');
    if (stage) {
      stage.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        const dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) {
          if (dx < 0) showIndex(currentIndex + 1);
          else showIndex(currentIndex - 1);
        }
        touchStartX = null;
      }, { passive: true });
    }
  });
})();

// ── PDP — QTY SELECTOR ────────────────────────────────────────
(function initQty() {
  const qtyDisplay = document.getElementById('qtyDisplay');
  const qtyMinus = document.getElementById('qtyMinus');
  const qtyPlus = document.getElementById('qtyPlus');
  const qtyInput = document.getElementById('qty-input');
  if (!qtyDisplay) return;
  qtyMinus.addEventListener('click', () => {
    if (_pdpQty > 1) {
      _pdpQty--;
      qtyDisplay.textContent = _pdpQty;
      if (qtyInput) qtyInput.value = _pdpQty;
      _pdpRefresh();
    }
  });
  qtyPlus.addEventListener('click', () => {
    _pdpQty++;
    qtyDisplay.textContent = _pdpQty;
    if (qtyInput) qtyInput.value = _pdpQty;
    _pdpRefresh();
  });
})();

// ── PDP — PURCHASE TABS ────────────────────────────────────────
(function initPurchaseTabs() {
  const tabOne = document.getElementById('tab-onetime');
  const tabSub = document.getElementById('tab-subscribe');
  if (!tabOne || !tabSub) return;
  tabOne.addEventListener('click', function() {
    this.classList.add('active');
    tabSub.classList.remove('active');
    _pdpIsSub = false;
    _pdpRefresh();
  });
  tabSub.addEventListener('click', function() {
    this.classList.add('active');
    tabOne.classList.remove('active');
    _pdpIsSub = true;
    _pdpRefresh();
  });
})();

// ── PDP — YMAL DRAG SCROLL ────────────────────────────────────
(function initYmalDragScroll() {
  const ymalScroll = document.querySelector('.ymal-scroll');
  if (!ymalScroll) return;
  let isDragging = false, lastX;
  ymalScroll.addEventListener('mousedown', e => {
    e.preventDefault();
    isDragging = true;
    lastX = e.clientX;
    ymalScroll.classList.add('is-grabbing');
    ymalScroll.style.userSelect = 'none';
  });
  ymalScroll.addEventListener('dragstart', e => e.preventDefault());
  document.addEventListener('mouseup', () => {
    if (!isDragging) return;
    isDragging = false;
    ymalScroll.classList.remove('is-grabbing');
    ymalScroll.style.userSelect = '';
  });
  document.addEventListener('mousemove', e => {
    if (!isDragging) return;
    const dx = e.clientX - lastX;
    ymalScroll.scrollLeft -= dx;
    lastX = e.clientX;
  });
})();

// ── PDP — ACCORDIONS ──────────────────────────────────────────
(function initAccordions() {
  document.querySelectorAll('.acc-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.acc-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.acc-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });
})();

// ── HEADER — STICKY SCROLL STATE ───────────────────────────────
(function initHeaderScroll() {
  const nav = document.getElementById('siteNav');
  if (!nav) return;
  const stickyMode = nav.dataset.stickyMode || 'always';
  let lastY = window.scrollY;

  function onScroll() {
    const y = window.scrollY;
    nav.classList.toggle('nav--scrolled', y > 24);

    if (stickyMode === 'scroll_up') {
      if (y > lastY && y > 80) {
        nav.classList.add('nav--hidden');
      } else {
        nav.classList.remove('nav--hidden');
      }
    }
    lastY = y;
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

// ── HEADER — MOBILE SUBMENU ACCORDION ──────────────────────────
(function initMobileSubmenu() {
  document.querySelectorAll('.nav-mobile-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.nav-mobile-item');
      if (item) item.classList.toggle('open');
    });
  });
})();

// ── HEADER — PREDICTIVE SEARCH ─────────────────────────────────
(function initPredictiveSearch() {
  const input = document.getElementById('searchInput');
  const resultsEl = document.getElementById('searchResults');
  if (!input || !resultsEl) return;

  // Overlay open/close controls only exist in "icon" search style — "bar" style
  // renders the same #searchInput/#searchResults inline with no overlay to toggle.
  const searchBtn = document.getElementById('navSearchBtn');
  const overlay = document.getElementById('searchOverlay');
  const closeBtn = document.getElementById('searchClose');
  if (searchBtn && overlay) {
    function open() {
      overlay.classList.add('open');
      setTimeout(() => input.focus(), 50);
    }
    function close() {
      overlay.classList.remove('open');
    }
    searchBtn.addEventListener('click', () => {
      overlay.classList.contains('open') ? close() : open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay.classList.contains('open')) close();
    });
  }

  let debounceTimer;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderResults(query, products) {
    if (!products.length) {
      resultsEl.innerHTML = '<p class="search-empty">No products found for "' + query.replace(/</g, '&lt;') + '"</p>';
      return;
    }
    const items = products.map(p => (
      '<a href="' + p.url + '" class="search-results-item">' +
        (p.image ? '<img src="' + p.image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '<div class="search-results-item-img-placeholder" style="width:48px;height:48px;background:#EDEAE4;flex-shrink:0;"></div>') +
        '<div class="search-results-item-body">' +
          '<p class="search-results-item-title">' + p.title + '</p>' +
          '<p class="search-results-item-price">' + (p.price_formatted || p.price || '') + (p.available === false ? ' · Sold Out' : '') + '</p>' +
        '</div>' +
      '</a>'
    )).join('');
    resultsEl.innerHTML = items + '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="search-view-all">View all results for "' + query.replace(/</g, '&lt;') + '" →</a>';
  }

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const query = input.value.trim();
    if (query.length < 2) {
      resultsEl.innerHTML = '';
      return;
    }
    resultsEl.innerHTML = '<p class="search-loading">Searching…</p>';
    debounceTimer = setTimeout(() => {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(res => res.json())
        .then(data => {
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(query, products.map(p => ({
            title: p.title,
            url: p.url,
            image: p.image,
            price_formatted: p.price,
            available: p.available
          })));
        })
        .catch(() => {
          resultsEl.innerHTML = '<p class="search-empty">Something went wrong. Try again.</p>';
        });
    }, 250);
  });
})();

// ── HEADER — ANNOUNCEMENT BAR ROTATION + DISMISS ───────────────
(function initAnnouncementBar() {
  const bar = document.getElementById('announcementBar');
  if (!bar) return;

  if (sessionStorage.getItem('fauntAnnouncementDismissed') === '1') {
    bar.style.display = 'none';
    return;
  }

  const items = bar.querySelectorAll('.announcement-item');
  const closeBtn = document.getElementById('announcementClose');
  const interval = (parseInt(bar.dataset.rotateInterval, 10) || 5) * 1000;

  if (items.length > 1) {
    let current = 0;
    setInterval(() => {
      items[current].classList.remove('active');
      current = (current + 1) % items.length;
      items[current].classList.add('active');
    }, interval);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      bar.style.display = 'none';
      sessionStorage.setItem('fauntAnnouncementDismissed', '1');
      syncStickyOffset();
    });
  }
})();

// ── HEADER — STICKY OFFSET (keeps nav/filter-bar/etc. stacked
//    correctly below a sticky announcement bar, if one is present) ──
function syncStickyOffset() {
  const bar = document.getElementById('announcementBar');
  let offset = 0;
  if (bar && bar.classList.contains('announcement-bar--sticky') && bar.offsetParent !== null && bar.style.display !== 'none') {
    offset = bar.offsetHeight;
  }
  document.documentElement.style.setProperty('--sticky-offset', offset + 'px');
}
syncStickyOffset();
window.addEventListener('resize', syncStickyOffset);

// ── CART SLIDE-OUT DRAWER ───────────────────────────────────────
(function initCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const backdrop = document.getElementById('cartDrawerBackdrop');
  const cartToggle = document.getElementById('navCartToggle');
  const closeBtn = document.getElementById('cartDrawerClose');
  const itemsEl = document.getElementById('cartDrawerItems');
  const footerEl = document.getElementById('cartDrawerFooter');
  const subtotalEl = document.getElementById('cartDrawerSubtotal');
  const navCount = document.getElementById('navCartCount');

  if (!drawer || !backdrop || !cartToggle) {
    window.FauntCart = { open: function () {}, close: function () {}, refresh: function () {} };
    return;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function syncHeaderCount(count) {
    if (!navCount) return;
    navCount.textContent = count;
    navCount.style.display = count > 0 ? '' : 'none';
  }

  function renderItem(item) {
    const variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="cart-drawer-item-variant">' + item.variant_title + '</p>' : '';
    const subscriptionLine = item.selling_plan_allocation
      ? '<p class="cart-drawer-item-subscription">' + item.selling_plan_allocation.selling_plan.name + '</p>' : '';
    return (
      '<div class="cart-drawer-item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-drawer-item-img">' +
          (item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="cart-drawer-item-body">' +
          '<div class="cart-drawer-item-top">' +
            '<div><a href="' + item.url + '" class="cart-drawer-item-name">' + item.product_title + '</a>' + variantLine + subscriptionLine + '</div>' +
            '<button type="button" class="cart-drawer-item-remove" data-cart-remove aria-label="Remove">&times;</button>' +
          '</div>' +
          '<div class="cart-drawer-item-bottom">' +
            '<div class="qty-selector cart-qty-selector">' +
              '<button type="button" class="qty-btn" data-cart-qty-minus aria-label="Decrease quantity">&#8722;</button>' +
              '<span class="qty-display" data-cart-qty-display>' + item.quantity + '</span>' +
              '<button type="button" class="qty-btn" data-cart-qty-plus aria-label="Increase quantity">&#43;</button>' +
            '</div>' +
            '<p class="cart-drawer-item-price" data-cart-line-price>' + formatMoney(item.final_line_price) + '</p>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function render(cart) {
    syncHeaderCount(cart.item_count);
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer-empty"><p class="cart-drawer-empty-text">Your cart is empty.</p><a href="/collections/all" class="btn-dark">Continue Shopping</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    if (footerEl) footerEl.style.display = '';
    itemsEl.innerHTML = cart.items.map(renderItem).join('');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function refresh() {
    return fetch('/cart.js').then(r => r.json()).then(cart => { render(cart); return cart; });
  }

  function open() {
    refresh().finally(() => {
      drawer.classList.add('open');
      backdrop.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }

  function close() {
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartToggle.addEventListener('click', e => {
    if (cartToggle.dataset.drawerEnabled !== 'true') return;
    e.preventDefault();
    open();
  });
  if (closeBtn) closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('open')) close();
  });

  function setRowBusy(row, busy) {
    row.classList.toggle('is-updating', busy);
  }

  function changeLine(row, quantity) {
    const key = row.dataset.key;
    setRowBusy(row, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(res => res.json())
      .then(cart => render(cart))
      .catch(() => setRowBusy(row, false));
  }

  itemsEl.addEventListener('click', e => {
    const row = e.target.closest('.cart-drawer-item');
    if (!row) return;
    if (e.target.closest('[data-cart-qty-plus]')) {
      const qtyDisplay = row.querySelector('[data-cart-qty-display]');
      changeLine(row, parseInt(qtyDisplay.textContent, 10) + 1);
    } else if (e.target.closest('[data-cart-qty-minus]')) {
      const qtyDisplay = row.querySelector('[data-cart-qty-display]');
      changeLine(row, Math.max(parseInt(qtyDisplay.textContent, 10) - 1, 0));
    } else if (e.target.closest('[data-cart-remove]')) {
      changeLine(row, 0);
    }
  });

  window.FauntCart = { open: open, close: close, refresh: refresh };
})();

// ── CART PAGE — LIVE QTY / REMOVE ───────────────────────────────
(function initCartPage() {
  const list = document.getElementById('cartItems');
  if (!list) return;

  const subtotalEl = document.getElementById('cartSubtotal');
  const checkoutBtn = document.getElementById('cartCheckoutBtn');
  const navCount = document.getElementById('navCartCount');

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function setRowBusy(row, busy) {
    row.classList.toggle('is-updating', busy);
  }

  function syncHeader(cart) {
    if (!navCount) return;
    navCount.textContent = cart.item_count;
    navCount.style.display = cart.item_count > 0 ? '' : 'none';
  }

  function changeLine(row, quantity) {
    const key = row.dataset.key;
    setRowBusy(row, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(res => res.json())
      .then(cart => {
        syncHeader(cart);
        const updatedItem = cart.items.find(i => i.key === key);

        if (!updatedItem) {
          row.remove();
        } else {
          const qtyDisplay = row.querySelector('[data-cart-qty-display]');
          const linePrice = row.querySelector('[data-cart-line-price]');
          if (qtyDisplay) qtyDisplay.textContent = updatedItem.quantity;
          if (linePrice) linePrice.textContent = formatMoney(updatedItem.final_line_price);
          setRowBusy(row, false);
        }

        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;

        if (cart.item_count === 0) window.location.reload();
      })
      .catch(() => setRowBusy(row, false));
  }

  list.addEventListener('click', e => {
    const row = e.target.closest('.cart-item');
    if (!row) return;

    if (e.target.closest('[data-cart-qty-plus]')) {
      const qtyDisplay = row.querySelector('[data-cart-qty-display]');
      const next = parseInt(qtyDisplay.textContent, 10) + 1;
      changeLine(row, next);
    } else if (e.target.closest('[data-cart-qty-minus]')) {
      const qtyDisplay = row.querySelector('[data-cart-qty-display]');
      const next = parseInt(qtyDisplay.textContent, 10) - 1;
      changeLine(row, Math.max(next, 0));
    } else if (e.target.closest('[data-cart-remove]')) {
      changeLine(row, 0);
    }
  });
})();

// ── QUICK ADD TO CART (shop cards, best sellers, YMAL) ──────────
(function initQuickAdd() {
  const buttons = document.querySelectorAll('[data-add-to-cart]');
  if (!buttons.length) return;

  const navCount = document.getElementById('navCartCount');

  function syncHeaderCount(count) {
    if (!navCount) return;
    navCount.textContent = count;
    navCount.style.display = count > 0 ? '' : 'none';
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variantId;
      if (!variantId || btn.classList.contains('is-adding')) return;

      const originalText = btn.textContent;
      btn.classList.add('is-adding');
      btn.disabled = true;

      const payload = { id: variantId, quantity: 1 };
      if (btn.dataset.sellingPlanId) payload.selling_plan = btn.dataset.sellingPlanId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(res => (res.ok ? res.json() : res.json().then(err => Promise.reject(err))))
        .then(() => fetch('/cart.js').then(r => r.json()))
        .then(cart => {
          syncHeaderCount(cart.item_count);
          btn.textContent = 'Added ✓';
          if (window.FauntCart) window.FauntCart.open();
        })
        .catch(() => {
          btn.textContent = 'Sold Out';
        })
        .finally(() => {
          setTimeout(() => {
            btn.textContent = originalText;
            btn.classList.remove('is-adding');
            btn.disabled = false;
          }, 1400);
        });
    });
  });
})();

// ── PRODUCT-MAIN (BLOCK-BASED PDP) — fully scoped, no global IDs ──
(function initProductMainBlocks() {
  document.querySelectorAll('[data-pdp-root]').forEach(function (root) {
    let qty = 1;

    const mainImg = root.querySelector('[data-pdp-main-image]');
    const mainVideos = root.querySelectorAll('[data-pdp-main-video]');
    const variantInput = root.querySelector('[data-pdp-variant-input]');
    const qtyInput = root.querySelector('[data-pdp-qty-input]');
    const sellingPlanInput = root.querySelector('[data-pdp-selling-plan-input]');
    const priceEl = root.querySelector('[data-pdp-price]');
    const comparePriceEl = root.querySelector('[data-pdp-compare-price]');
    const discountBadgeEl = root.querySelector('[data-pdp-discount-badge]');
    const onetimePriceEl = root.querySelector('[data-pdp-onetime-price]');
    const subscribePriceEl = root.querySelector('[data-pdp-subscribe-price]');
    const tabOnetime = root.querySelector('[data-pdp-tab-onetime]');
    const tabSubscribe = root.querySelector('[data-pdp-tab-subscribe]');
    const planPicker = root.querySelector('[data-pdp-plan-picker]');
    const atcBtn = root.querySelector('[data-pdp-atc-btn]');
    const form = root.querySelector('form');
    const stickyAtc = root.querySelector('[data-pdp-sticky-atc]');
    const stickyImg = stickyAtc ? stickyAtc.querySelector('[data-pdp-sticky-image]') : null;
    const stickyPriceEl = stickyAtc ? stickyAtc.querySelector('[data-pdp-sticky-price]') : null;
    const stickyComparePriceEl = stickyAtc ? stickyAtc.querySelector('[data-pdp-sticky-compare-price]') : null;
    const stickyDiscountBadgeEl = stickyAtc ? stickyAtc.querySelector('[data-pdp-sticky-discount-badge]') : null;
    const stickyBtn = stickyAtc ? stickyAtc.querySelector('[data-pdp-sticky-atc-btn]') : null;
    const imageBadge = root.querySelector('[data-pdp-image-badge]');
    const firstThumb = root.querySelector('[data-pdp-thumb]');
    const discountFormat = root.dataset.discountFormat === 'dollar' ? 'dollar' : 'percent';
    let discountText = '';

    // Countdown Timer block — a self-resetting, globally-synced countdown.
    // Instead of tracking a start date per visitor, it derives the remaining
    // time from the current clock modulo the configured duration, so it
    // reaches zero and restarts the same cycle forever with no stored state
    // and identically for every visitor.
    root.querySelectorAll('[data-pdp-countdown]').forEach(function (countdownEl) {
      const duration = parseInt(countdownEl.dataset.durationSeconds, 10) || (48 * 3600);
      const daysEl = countdownEl.querySelector('[data-pdp-countdown-days]');
      const hoursEl = countdownEl.querySelector('[data-pdp-countdown-hours]');
      const minutesEl = countdownEl.querySelector('[data-pdp-countdown-minutes]');
      const secondsEl = countdownEl.querySelector('[data-pdp-countdown-seconds]');

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        const nowSeconds = Math.floor(Date.now() / 1000);
        const remaining = duration - (nowSeconds % duration);
        if (daysEl) daysEl.textContent = pad(Math.floor(remaining / 86400));
        if (hoursEl) hoursEl.textContent = pad(Math.floor((remaining % 86400) / 3600));
        if (minutesEl) minutesEl.textContent = pad(Math.floor((remaining % 3600) / 60));
        if (secondsEl) secondsEl.textContent = pad(remaining % 60);
      }

      tick();
      setInterval(tick, 1000);
    });

    function setImage(src) {
      if (!mainImg || !src) return;
      hideMainVideos();
      if (mainImg) mainImg.hidden = false;
      mainImg.classList.add('fade');
      setTimeout(() => {
        mainImg.src = src;
        mainImg.classList.remove('fade');
      }, 280);
    }

    function hideMainVideos() {
      mainVideos.forEach(function (wrap) {
        wrap.hidden = true;
        const video = wrap.querySelector('video');
        if (video) video.pause();
      });
    }

    function showMainVideo(mediaId) {
      hideMainVideos();
      if (mainImg) mainImg.hidden = true;
      const wrap = root.querySelector('[data-pdp-main-video][data-media-id="' + mediaId + '"]');
      if (!wrap) return;
      wrap.hidden = false;
      const video = wrap.querySelector('video');
      if (video) video.play().catch(function () {});
    }

    function syncSellingPlanInput() {
      if (!sellingPlanInput || !tabSubscribe) return;
      const isSub = tabSubscribe.classList.contains('active');
      sellingPlanInput.value = isSub ? (tabSubscribe.dataset.sellingPlanId || '') : '';
    }

    // Applies a selling plan's id/price to the Subscribe tab (used both when
    // a plan pill is clicked and when the active variant changes, so the
    // currently-selected interval's price stays correct for whichever variant
    // is selected).
    function applyPlanPrice(planId, priceStr, displayStr) {
      if (!tabSubscribe || !priceStr) return;
      tabSubscribe.dataset.sellingPlanId = planId;
      tabSubscribe.dataset.price = priceStr;
      if (subscribePriceEl) subscribePriceEl.textContent = displayStr || priceStr;
      syncSellingPlanInput();
      updateTopPrice();
      updateImageBadge();
    }

    function getActivePlanId() {
      if (!planPicker) return tabSubscribe ? tabSubscribe.dataset.sellingPlanId : null;
      const activePill = planPicker.querySelector('[data-pdp-plan-option].active');
      return activePill ? activePill.dataset.sellingPlanId : null;
    }

    // Renders the price shown up top (and mirrored in the sticky bar) from
    // whichever purchase tab (One Time / Subscribe & Save) is currently active,
    // plus the compare-at price and discount badge for the currently selected variant.
    // The badge is always Compare at Price vs the shown price, as "% OFF" or "$ OFF"
    // per the section's Discount format (same math as the initial Liquid render).
    function updateTopPrice() {
      const isSub = !!(tabSubscribe && tabSubscribe.classList.contains('active'));
      const priceStr = isSub
        ? (tabSubscribe && tabSubscribe.dataset.price)
        : (tabOnetime && tabOnetime.dataset.price);
      if (!priceStr) return;

      const activeSwatch = root.querySelector('[data-pdp-variant-swatch].active');
      const hasCompare = activeSwatch
        ? activeSwatch.dataset.hasCompare === 'true'
        : (comparePriceEl ? !comparePriceEl.hidden : false);
      const compareStr = activeSwatch ? activeSwatch.dataset.comparePrice : (comparePriceEl ? comparePriceEl.textContent : '');

      const priceCents = _parseCents(priceStr);
      const compareCents = hasCompare ? _parseCents(compareStr) : 0;
      const showCompare = hasCompare && compareCents > priceCents;
      discountText = '';
      if (showCompare) {
        const savingsCents = compareCents - priceCents;
        if (discountFormat === 'dollar') {
          discountText = '$' + (savingsCents % 100 === 0 ? savingsCents / 100 : (savingsCents / 100).toFixed(2)) + ' OFF';
        } else {
          const percent = Math.round(savingsCents * 100 / compareCents);
          if (percent > 0) discountText = percent + '% OFF';
        }
      }

      [
        { price: priceEl, compare: comparePriceEl, badge: discountBadgeEl },
        { price: stickyPriceEl, compare: stickyComparePriceEl, badge: stickyDiscountBadgeEl }
      ].forEach(function (group) {
        if (group.price) group.price.textContent = priceStr;
        if (group.compare) {
          group.compare.hidden = !showCompare;
          if (showCompare) group.compare.textContent = compareStr;
        }
        if (group.badge) {
          group.badge.hidden = !discountText;
          if (discountText) group.badge.textContent = discountText;
        }
      });
    }

    // Product image badge — shows the same discount text as the price badge
    // (set by updateTopPrice, which always runs first), only on the first image.
    function updateImageBadge() {
      if (!imageBadge) return;
      const isFirstImageActive = !firstThumb || firstThumb.classList.contains('active');
      if (discountText) imageBadge.textContent = discountText;
      imageBadge.hidden = !(discountText && isFirstImageActive);
    }

    // Variant swatches
    root.querySelectorAll('[data-pdp-variant-swatch]').forEach(btn => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('[data-pdp-variant-swatch]').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        if (variantInput) variantInput.value = btn.dataset.variantId;
        setImage(btn.dataset.image);
        if (onetimePriceEl && btn.dataset.price) onetimePriceEl.textContent = btn.dataset.price;
        if (tabOnetime && btn.dataset.price) tabOnetime.dataset.price = btn.dataset.price;

        // Re-sync every plan pill's price to this variant, then re-apply
        // whichever plan is currently selected (not always the first) so
        // Subscribe & Save reflects the right price (and savings label) for
        // this variant + interval.
        let matchedPlan = null;
        if (btn.dataset.planPrices) {
          try {
            const planPrices = JSON.parse(btn.dataset.planPrices);
            if (planPicker) {
              planPicker.querySelectorAll('[data-pdp-plan-option]').forEach(pill => {
                const match = planPrices.find(p => String(p.id) === pill.dataset.sellingPlanId);
                if (match) pill.dataset.price = match.price;
              });
            }
            const activePlanId = getActivePlanId();
            matchedPlan = planPrices.find(p => String(p.id) === String(activePlanId));
          } catch (err) { /* fall through to subPrice below */ }
        }
        if (matchedPlan) {
          const display = matchedPlan.save > 0 ? matchedPlan.price + ' · Save ' + _fmtCents(matchedPlan.save) : matchedPlan.price;
          applyPlanPrice(getActivePlanId(), matchedPlan.price, display);
        } else if (btn.dataset.subPrice) {
          if (subscribePriceEl) subscribePriceEl.textContent = btn.dataset.subDisplay || btn.dataset.subPrice;
          if (tabSubscribe) tabSubscribe.dataset.price = btn.dataset.subPrice;
        }

        const isAvailable = btn.dataset.available === 'true';
        if (atcBtn) {
          atcBtn.disabled = !isAvailable;
          atcBtn.textContent = isAvailable ? atcBtn.dataset.availableText : 'Sold Out';
        }
        if (stickyImg && btn.dataset.image) stickyImg.src = btn.dataset.image;
        if (stickyBtn) {
          stickyBtn.disabled = !isAvailable;
          stickyBtn.textContent = isAvailable ? stickyBtn.dataset.availableText : 'Sold Out';
        }

        updateTopPrice();
        updateImageBadge();
      });
    });

    // Thumbnails
    root.querySelectorAll('[data-pdp-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        root.querySelectorAll('[data-pdp-thumb]').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (thumb.dataset.type === 'video') {
          showMainVideo(thumb.dataset.mediaId);
        } else {
          setImage(thumb.dataset.src);
        }
        // The discount badge only ever represents the first gallery image.
        updateImageBadge();
      });
    });

    // Quantity stepper
    const qtyDisplay = root.querySelector('[data-pdp-qty-display]');
    const qtyMinus = root.querySelector('[data-pdp-qty-minus]');
    const qtyPlus = root.querySelector('[data-pdp-qty-plus]');
    if (qtyMinus && qtyPlus && qtyDisplay) {
      qtyMinus.addEventListener('click', () => {
        if (qty > 1) {
          qty--;
          qtyDisplay.textContent = qty;
          if (qtyInput) qtyInput.value = qty;
        }
      });
      qtyPlus.addEventListener('click', () => {
        qty++;
        qtyDisplay.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      });
    }

    // Purchase type tabs
    if (tabOnetime && tabSubscribe) {
      tabOnetime.addEventListener('click', () => {
        tabOnetime.classList.add('active');
        tabSubscribe.classList.remove('active');
        if (planPicker) planPicker.hidden = true;
        syncSellingPlanInput();
        updateTopPrice();
        updateImageBadge();
      });
      tabSubscribe.addEventListener('click', () => {
        tabSubscribe.classList.add('active');
        tabOnetime.classList.remove('active');
        if (planPicker) planPicker.hidden = false;
        syncSellingPlanInput();
        updateTopPrice();
        updateImageBadge();
      });
    }

    // Delivery interval pills (1 month / 2 months / 3 months, etc.)
    if (planPicker) {
      planPicker.querySelectorAll('[data-pdp-plan-option]').forEach(pill => {
        pill.addEventListener('click', () => {
          planPicker.querySelectorAll('[data-pdp-plan-option]').forEach(p => p.classList.remove('active'));
          pill.classList.add('active');
          applyPlanPrice(pill.dataset.sellingPlanId, pill.dataset.price);
        });
      });
    }

    // Initialize hidden selling_plan input to match whichever tab is active by default
    syncSellingPlanInput();
    updateTopPrice();
    updateImageBadge();

    // Add to Cart — intercepts the native form submit, adds via the cart AJAX API,
    // then either opens the mini-cart drawer (same window.FauntCart API the quick-add
    // buttons use) or sends the customer straight to checkout, depending on the
    // "Enable Mini Cart" block setting (data-mini-cart-enabled). The sticky bar's
    // button submits this same <form> via its form="..." attribute, so both buttons
    // are covered by this one handler and always share the same setting value.
    if (form && atcBtn) {
      const submitButtons = [atcBtn, stickyBtn].filter(Boolean);
      const miniCartEnabled = atcBtn.dataset.miniCartEnabled !== 'false';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atcBtn.disabled) return;

        const originalTexts = submitButtons.map(function (b) { return b.textContent; });
        submitButtons.forEach(function (b) {
          b.disabled = true;
          b.textContent = miniCartEnabled ? 'Adding…' : 'Redirecting…';
        });

        const payload = {
          id: variantInput ? variantInput.value : undefined,
          quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
        };
        if (sellingPlanInput && sellingPlanInput.value) payload.selling_plan = sellingPlanInput.value;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            return res.ok ? res.json() : res.json().then(function (err) { return Promise.reject(err); });
          })
          .then(function () {
            if (miniCartEnabled) {
              if (window.FauntCart) window.FauntCart.open();
            } else {
              window.location.href = '/checkout';
            }
          })
          .catch(function () {
            submitButtons.forEach(function (b) { b.textContent = 'Error — try again'; });
          })
          .finally(function () {
            setTimeout(function () {
              submitButtons.forEach(function (b, i) {
                b.disabled = false;
                b.textContent = originalTexts[i];
              });
            }, 1400);
          });
      });
    }

    // Sticky Add to Cart bar — shows whenever the main Add to Cart button is
    // out of view (still below the fold on landing, or scrolled past above),
    // hides while the main button is on screen. While the main button is still
    // below the fold the bar is compact (full-width button only); once it has
    // been scrolled past, the full bar (image, title, price) is shown.
    if (stickyAtc && atcBtn && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          const show = !entry.isIntersecting;
          // Only switch layout while visible, so the bar doesn't reflow mid slide-out.
          if (show) stickyAtc.classList.toggle('pdp-sticky-atc--compact', entry.boundingClientRect.top > 0);
          stickyAtc.classList.toggle('pdp-sticky-atc--visible', show);
          stickyAtc.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      stickyObserver.observe(atcBtn);
    }
  });
})();

// ── IMAGE CAROUSEL (full-bleed, sliding track, autoplay) ────────
(function initImageCarousels() {
  document.querySelectorAll('[data-img-carousel]').forEach(function (carousel) {
    const track = carousel.querySelector('[data-img-carousel-track]');
    const slides = carousel.querySelectorAll('[data-img-carousel-slide]');
    const dots = carousel.querySelectorAll('[data-img-carousel-dots] .img-carousel-dot');
    if (!track || slides.length < 2) return;

    const interval = (parseInt(carousel.dataset.interval, 10) || 3) * 1000;
    let index = 0;

    // Container height tracks the active slide's own image — so the box is
    // exactly as tall as that image needs (responsive to the image, not a
    // fixed full-screen box), instead of cropping (cover) or letterboxing (contain).
    function syncHeight() {
      const img = slides[index].querySelector('img');
      if (!img) return;
      const apply = function () {
        carousel.style.height = img.getBoundingClientRect().height + 'px';
      };
      if (img.complete && img.naturalWidth) apply();
      else img.addEventListener('load', apply, { once: true });
    }

    function goTo(i) {
      index = i;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (dot, n) { dot.classList.toggle('active', n === index); });
      syncHeight();
    }

    syncHeight();
    window.addEventListener('resize', syncHeight);

    setInterval(function () {
      goTo((index + 1) % slides.length);
    }, interval);
  });
})();

// ── VIDEO HERO (advances when each video ends, box tracks video size) ──
(function initVideoHeroes() {
  document.querySelectorAll('[data-video-hero]').forEach(function (hero) {
    const slides = hero.querySelectorAll('[data-video-hero-slide]');
    const dots = hero.querySelectorAll('[data-video-hero-dots] .video-hero-dot');
    if (!slides.length) return;

    let index = 0;

    // Container height tracks the active slide's own media — so the box is
    // exactly as tall as that video/image needs, responsive to it, rather
    // than a fixed full-screen crop.
    function syncHeight() {
      const media = slides[index].querySelector('video, img');
      if (!media) return;
      const apply = function () {
        hero.style.height = media.getBoundingClientRect().height + 'px';
      };
      if (media.tagName === 'VIDEO') {
        if (media.readyState >= 1) apply();
        else media.addEventListener('loadedmetadata', apply, { once: true });
      } else if (media.complete && media.naturalWidth) {
        apply();
      } else {
        media.addEventListener('load', apply, { once: true });
      }
    }

    function activate(i) {
      index = i;
      slides.forEach(function (slide, n) {
        const video = slide.querySelector('video');
        slide.classList.toggle('active', n === i);
        if (dots[n]) dots[n].classList.toggle('active', n === i);
        if (!video) return;
        if (n === i) {
          video.currentTime = 0;
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
      syncHeight();
    }

    slides.forEach(function (slide) {
      const video = slide.querySelector('video');
      if (!video) return;
      video.addEventListener('ended', function () {
        activate((index + 1) % slides.length);
      });
    });

    window.addEventListener('resize', syncHeight);
    activate(0);
  });
})();

// ── SMOOTH ANCHOR-LINK SCROLL (GSAP-eased, native scroll untouched) ──
try {
  (function initSmoothAnchorScroll() {
    if (!window.gsap || !window.ScrollToPlugin) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    gsap.registerPlugin(ScrollToPlugin);

    document.addEventListener('click', e => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute('href').slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;

      e.preventDefault();
      const nav = document.getElementById('siteNav');
      const stickyOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-offset'), 10) || 0;
      const clearance = (nav ? nav.offsetHeight : 64) + stickyOffset + 16;
      gsap.to(window, {
        duration: 0.9,
        scrollTo: { y: target, offsetY: clearance },
        ease: 'power3.out'
      });
    });
  })();
} catch (err) {
  console.warn('[faunt] smooth anchor scroll failed to init:', err);
}
